export const parseKvpField = (raw?: string): Record<string, string> => {
  const result: Record<string, string> = {};
  if (!raw) return result;

  for (const pair of raw.split("&")) {
    const [key, value] = pair.split("=");
    if (key && value !== undefined) {
      result[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  }
  return result;
};
